import React from "react";
import { Typography, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import OrderFileUpload from "../OrderFileUpload";
import OrderDocumentsList from "../OrderDocumentsList/OrderDocumentsList";
import {
  Container,
  HeaderRow,
  Title,
  UploadButton,     // reuse existing styled button; just change the label/action
  FileRow,
} from "./OrderDetailsDocuments.styles";

/**
 * Shows file upload functionality for admin or document list for users.
 * Determines context based on user role and shows appropriate component.
 */
export default function OrderDetailsDocuments({ order }) {
  // Get order number from props
  const orderNumber = order?.order_number;
  
  // Check if user is admin
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  return (
    <Container>
      <HeaderRow>
        <Title>Order Details & Documents</Title>
      </HeaderRow>

      {/* Show upload component for admins, document list for users */}
      {orderNumber && (
        <>
          {isAdmin ? (
            <OrderFileUpload orderNumber={orderNumber} />
          ) : (
            <OrderDocumentsList orderNumber={orderNumber} />
          )}
        </>
      )}
    </Container>
  );
}
